module.exports = __webpack_public_path__ + "static/media/ga.f64e29ed.svg";